import React from 'react';
import { connect } from 'react-redux';
import {
  resetCardInstallments,
  clearSaveCardCheckbox,
  setSaveCardCheckbox,
} from '../../../../redux/actions/uiStateActions';
import { CreditCardController } from './controller';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  setSaveCardCheckbox,
  clearSaveCardCheckbox,
  resetCardInstallments,
};

type ComponentProps = React.ComponentProps<typeof CreditCardController>;
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
type OwnProps = Omit<ComponentProps, keyof (StateProps & DispatchProps)>;

export const CreditCardControllerConnect = connect<
  StateProps,
  DispatchProps,
  OwnProps
>(
  mapStateToProps,
  mapDispatchToProps
)(CreditCardController);
